import React from 'react';
import EditionList from './EditionList';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { size, get } from 'global/lib/lodash';
import { Courses } from '../courses';
import { CenterContent, LeftSideBar, GridContainer } from 'global/components/perform-grid';
import { FilterChips } from 'global/components/filterchips';
import { useScreen } from 'global/styles';
import EditionsFilters from 'feature/document/Filters/EditionsFilters';
import NavToTop from 'feature/nav/NavToTop';
import useStyles from './Edition.styles';
import { sortByDate } from 'global/utils';
import { Text } from 'global/components/text';
import LibraryIcon from '@mui/icons-material/Book';

const include = ['assessment', 'edition', 'edition.documents'].join(',');

export default (props) => {
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });
  const courses = useRetrieveData(
    { url: `/course-assignments` },
    {
      build: ['courseAssignments'],
      params: {
        filter: { context: 'my' },
        include,
      },
      transformData: (d) => sortByDate(d, 'updatedAt'),
    }
  );

  const coursereview = useRetrieveData(
    { url: `/course-assignments` },
    {
      build: ['courseAssignments'],
      params: {
        filter: { role: 'reviewer' },
        include,
      },
      transformData: (d) => sortByDate(d, 'updatedAt'),
    }
  );

  const showCourses = get(props, 'showCourses', true) && !courses.loading && !!size(courses.data);
  const showreview = get(props, 'showReview', true) && !coursereview.loading && !!size(coursereview.data);

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <EditionsFilters {...props} display={'editions'} courses={courses} />
      </LeftSideBar>

      <CenterContent ignoreRight className={classes.container}>
        <NavToTop />
        <h2 className={classes.title}>
          <LibraryIcon className={classes.icon} />
          Library
        </h2>
        {isMobile ? <EditionsFilters {...props} display={'editions'} courses={courses} /> : <FilterChips id={'library.editions'} />}
        {showCourses && <Courses {...props} {...courses} />}
        {showreview && <Courses {...coursereview} isReview />}
        <Text type="headline_medium" style={{display: isMobile && !showCourses && !showreview ? 'none' : undefined}}>
          Library Reference
        </Text>
        <EditionList {...props} courses={courses} coursesLoading={courses.loading} />
      </CenterContent>
    </GridContainer>
  );
};
